<template>
  <div class="footer-wrapper">
    <!-- adding footer -->
    <footer class="footer-appointment">
      <!-- adding footer top -->
      <section class="footer-top">
        <div class="text-right float-right full-width">
          <div class="today-wrapper float-left">
            <a href="#" @click.stop.prevent="goToDaily">Today</a>
          </div>
        </div>
      </section>
      <p class="d-inline">
        PSYBooks, LLC &copy; {{ new Date().getFullYear() }}
      </p>
    </footer>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations({
      setDayOfMonth: "setDayOfMonth",
      setMonth: "setMonth",
      setYear: "setYear",
      setWeek: "setWeek"
    }),
    goToDaily() {
      const today = new Date();
      this.setDayOfMonth(today.getDate());
      this.setWeek(today.getDate());
      this.setMonth(today.getMonth());
      this.setYear(today.getFullYear());
      if (this.$router.history.current.name !== "Daily") {
        this.$router.push("/daily");
      }
    }
  }
};
</script>
